import { ControlcenterMelcoModelsEmailListItem } from "melco-shared-logic";
import { useEmailPreview } from "../../../hooks/emailhistory/useEmailPreview";

export type SubmitAction = "edit";

export type EmailPreviewFormValueInterface = {
  id: string | null;
  emailAddress: string;
  // timeStamp: Date;
};

type EmailPreviewFormProps = {
  // referenceDrawer: DrawerType
  onCloseDrawer: (closeDrawer: boolean) => void;
  emailRowObject: ControlcenterMelcoModelsEmailListItem;
};

export const EmailPreviewForm: React.FC<EmailPreviewFormProps> = ({
  // referenceDrawer,
  // onCloseDrawer,
  emailRowObject,
}) => {
  // const token = useUserToken();
  const response = useEmailPreview(emailRowObject.id ?? "");
  console.log(response);
  const htmlToRender = response.data?.html ?? "";
  //const htmlToRender = "";

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: htmlToRender }} />
    </>
  );
};
